import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserRoleService } from '../services/role.service';

@Injectable({
    providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
    constructor(
        private userRoleService: UserRoleService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.userRoleService.getCurrentUser().pipe(
            map((user) => {
                const userRole = this.userRoleService.getHighestRole(user);
                return this.router.parseUrl(this.resolveRoute(userRole));
            }),
            catchError((error) => {
                console.error('Error in home redirect guard:', error);
                return of(this.router.parseUrl('/home'));
            })
        );
    }

    private resolveRoute(role: string): string {
        switch (role) {
            case 'superadmin':
                return '/center-management';
            case 'groupadmin':
                return '/storage';
            case 'centeradmin':
                return '/home';
            case 'centeruser':
                return '/calendar';
            default:
                return '/home';
        }
    }
} 
